import { useStore } from "vuex"
import GetLabel from "foundation/js/getLabel"

export default {
    name: "DeleteEventModal",
    setup(){
        const store = useStore()

        const deletePost = () => {
            store.state.main.page_overlay_content_data.callback()
        }

        return {
            getLabel: (labelKey) => GetLabel({ labelKey, labelCollection: 'DeleteEventModal' }),
            deletePost
        }
    }
}